<ng-continer *ngIf="!moveToAddModule">
    <div class="topHead">
        <a href="javascript:void(0);" class="adminBack" (click)="open(back)"><img
                src="assets/images/admin/backarrow.png" /> Back to course Management</a>
        <!-- <div class="logout">
            <b>{{adminData.first_name+" " + adminData.last_name}}</b>
            <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png" /> </a>
        </div> -->
        <div class="logout">
            <app-log-out class="logout"></app-log-out>
        </div>
    </div>
    <div class="formHeading pr-0">
        <div class="row m-0">
            <div class="col-12 col-md-4">
                <h2 *ngIf="!type">Create Module</h2>
                <h2 *ngIf="type">Edit Module</h2>
                <p>Please add the following information to create a new course</p>
            </div>
            <!-- <div class="col-12 col-md-4">
    <div class="filterWrap">
        <div class="searchWrap mr-0">
            <input type="text" placeholder="Search Users">
        </div>
    </div>
</div> -->
            <!-- <div class="col-12 col-md-4">
    <div class="filterSelect">
        <span>Filter by Organisation:</span>
        <div class="selectCustom">
            <select>
                <option>All</option>
                <option>Select 02</option>
                <option>Select 03</option>
            </select>
        </div>
    </div>
</div> -->
        </div>
    </div>
    <ngx-spinner>
        <p style="color: white"> Loading... </p>
    </ngx-spinner>
    <form [formGroup]="courseModuelAuthForm">
        <div class="sttperWrap">
            <div class="sttperHead">
                <ul>
                    <li>
                        <!-- <a href="javascript:void(0);" class="active" [routerLink]="['/courses_create']"><b>01</b>Course Details</a> -->
                        <a href="javascript:void(0);" class="active"><b>01</b>Course Details</a>
                    </li>
                    <li>
                        <!-- <a href="javascript:void(0);" class="active" [routerLink]="['/courses_add_modules']"><b>02</b>Add Modules</a> -->
                        <a href="javascript:void(0);" class="active"><b>02</b>Add Modules</a>
                    </li>
                    <li>
                        <!-- <a href="javascript:void(0);" class="events-none" [routerLink]="['/courses_add_review']"><b>03</b>Review</a> -->
                        <a href="javascript:void(0);" class="events-none"><b>03</b>Review</a>
                    </li>
                    <li *ngIf="!type">
                        <!-- <a href="javascript:void(0);" class="events-none" [routerLink]="['/courses_add_assign_user']"><b>04</b>Assign Users</a> -->
                        <a href="javascript:void(0);" class="events-none"><b>04</b>Assign Users</a>
                    </li>
                </ul>
            </div>

            <div class="sttperBody mt-4">
                <div class="sttpermoudle mb-4">
                    <div class="sttpermoudleHead">
                        <span *ngFor="let valueModu of countModule; let i=index">
                            <span  [ngClass]="(selectModuleId == valueModu.id) || (  valueModu.id =='' && selectModuleId =='') ? 'active' : ''" >
                           <b
                                (click)="getModuleDetails(valueModu.id,i)">MODULE {{i+1}}</b>
                            <i *ngIf="this.countModule.length > 1" (click)="opens(delete,valueModu.id,i)"><img
                                    src="assets/images/admin/close_gray_big.png" /></i></span></span>
                        <!-- <b><img src="assets/images/admin/add.png" [ngClass]=" (moduleName.value.length < 1 || moduleDesc.value.length < 1) ? 'btn-sm ml-1 mr-1  disableborder ' : 'btn-sm btn-secondary ml-1 mr-1' " (click)="createCourseAddModules(1,1)"/> </b> -->
                        <b [ngClass]=" (moduleName.value.length < 1 || moduleDesc.value.length < 1) ? 'btn-sm ml-1 mr-1  disableborder ' : 'btn-sm btn-secondary ml-1 mr-1' " (click)="createCourseAddModules(1,1)">+</b>
                    </div>
                </div>
                <div class="addModule">
                    <div class="row m-0">
                        <div class="col-5">

                            <div class="commanInput commanTextarea">
                                <mat-form-field class="example-full-width">
                                    <mat-label>Module Name</mat-label>
                                    <textarea matInput #moduleName maxlength="50" placeholder="Enter Module Name"
                                        formControlName="module_name" (change)="AutoSave()"></textarea>
                                    <mat-hint align="end">{{moduleName.value.length}} / 50 characters</mat-hint>
                                </mat-form-field>
                                <div *ngIf="submitted && f.module_name.errors">
                                    <div *ngIf="f.module_name.errors.required" class="text-mute text-danger errorText">
                                        This field
                                        is required</div>
                                    <!-- <div *ngIf="f.assessment_instruction.errors.cannotContainSpace" class="text-mute text-danger errorText">CapsuleName can not contain space.</div> -->
                                </div>

                            </div>
                        </div>
                        <div class="col-7">
                            <div class="commanInput commanTextarea">
                                <mat-form-field class="example-full-width">
                                    <mat-label>Module Description</mat-label>
                                    <textarea matInput #moduleDesc maxlength="250"
                                        placeholder="Enter Module Description" formControlName="module_desc" (change)="AutoSave()"></textarea>
                                    <mat-hint align="end">{{moduleDesc.value.length}} / 250 characters</mat-hint>
                                </mat-form-field>
                                <div *ngIf="submitted && f.module_desc.errors">
                                    <div *ngIf="f.module_desc.errors.required" class="text-mute text-danger errorText">
                                        This field
                                        is required</div>
                                    <!-- <div *ngIf="f.assessment_instruction.errors.cannotContainSpace" class="text-mute text-danger errorText">CapsuleName can not contain space.</div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="addSubModule" formArrayName="subModules">
                    <div  class="reportRelative" *ngFor="let itemrow of courseModuelAuthForm.controls.subModules['controls']; let i=index">
                        <div [formGroupName]="i">
                            <h6>SUBMODULE {{i+1}}</h6>
                            <div ><a href="javascript:void(0);" (click)="deleteSubModule(i)"
                                class="btn-remove subModule float-right"><img src="assets/images/admin/delete.svg" />
                                Remove</a></div>
                            <div class="row m-0 pl-2 pr-2">
                                <div class="col-5">
                                    <div class="commanInput commanTextarea">
                                        <mat-form-field class="example-full-width">
                                            <mat-label>Sub Module Name</mat-label>
                                            <textarea matInput #subcourseName maxlength="50"
                                                placeholder="Enter Sub Module Name" (change)="AutoSave()"
                                                formControlName="submodule_name"></textarea>
                                            <mat-hint align="end">{{subcourseName.value.length}} / 50 characters
                                            </mat-hint>
                                        </mat-form-field>
                                        <div *ngIf="courseModuelAuthForm.get('subModules').controls[i].get('submodule_name')?.dirty &&
                      courseModuelAuthForm.get('subModules').controls[i].get('submodule_name')?.errors">
                                            <div *ngIf="courseModuelAuthForm.get('subModules').controls[i].get('submodule_name').errors.required"
                                                class="text-mute text-danger errorText">This field is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-7">
                                    <div class="commanInput commanTextarea">
                                        <mat-form-field class="example-full-width">
                                            <mat-label>Sub Module Description</mat-label>
                                            <textarea matInput #subcourseDesc maxlength="250"
                                                placeholder="Enter Sub Module Description" (change)="AutoSave()"
                                                formControlName="submodule_desc"></textarea>
                                            <mat-hint align="end">{{subcourseDesc.value.length}} / 250 characters
                                            </mat-hint>
                                        </mat-form-field>
                                        <div *ngIf="courseModuelAuthForm.get('subModules').controls[i].get('submodule_desc')?.dirty &&
                      courseModuelAuthForm.get('subModules').controls[i].get('submodule_desc')?.errors">
                                            <div *ngIf="courseModuelAuthForm.get('subModules').controls[i].get('submodule_desc').errors.required"
                                                class="text-mute text-danger errorText">This field is required
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="row m-0 mb-4 mt-4 pl-4 pr-4" *ngIf="capsuleAssign[i]">
                                <div class="col-6">
                                    <span class="viewTitle">Content Capsule</span>
                                    <p class="viewcontent">{{capsuleAssignData[i]['capsule_name']}}</p>
                                </div>
                                <div class="col-6">
                                    <div class="contentAction">
                                        <ul class="modifyIcons" *ngIf="capsuleAssignData[i]['contentCapsuleMedia']">
                                            <li *ngIf="capsuleAssignData[i]['assessment_id']"><a
                                                    href="javascript:void(0);"><img
                                                        src="assets/images/icons/frame.svg"></a></li>
                                            <li
                                                *ngIf="(getMediaType(capsuleAssignData[i]['contentCapsuleMedia'],'1')==true)">
                                                <a href="javascript:void(0);"><img
                                                        src="assets/images/icons/text.svg"></a>
                                            </li>
                                            <li
                                                *ngIf="(getMediaType(capsuleAssignData[i]['contentCapsuleMedia'],'2')==true)">
                                                <a href="javascript:void(0);"><img
                                                        src="assets/images/icons/insert-picture.svg"></a></li>
                                            <li
                                                *ngIf="(getMediaType(capsuleAssignData[i]['contentCapsuleMedia'],'3')==true)">
                                                <a href="javascript:void(0);"><img
                                                        src="assets/images/icons/video-camera.svg"></a></li>
                                        </ul>
                                        <a href="javascript:void(0);"  class="btn-link" (click)="viewCapsule(capsuleAssignData[i]['content_capsule_id'])">VIEW CONTENT</a>
                                        <!-- <a href="javascript:void(0);" class="btn-link">VIEW CONTENT</a> -->
                                        <a href="javascript:void(0);" (click)="deleteCapsule(i)" class="btn-remove"><img
                                                src="assets/images/admin/delete.svg" />Remove</a>
                                    </div>
                                </div>
                            </div>
                            <div class="addContentWrap pl-4 pr-4" *ngIf="capsuleAssign[i] == null || capsuleAssign[i] == ''">
                                <a href="javascript:void(0);" class="btn-link" (click)="addCapsule(i)">+ ADD content
                                    capsule</a>
                                <div *ngIf="submitted && ( capsuleAssign[i] == null || capsuleAssign[i] == '')">
                                    <div class="text-mute text-danger errorText">Please Add content capsule</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="addContentWrap pl-5 pr-5" *ngIf="moduleName.value.length > 1 && moduleDesc.value.length > 1">
                    <a href="javascript:void(0);" class="btn-link" (click)="addNewSubModule()">+ ADD submodule</a>
                    <div *ngIf="submitted && subModError == 1">
                        <div class="text-mute text-danger errorText">Please Add submodule</div>
                    </div>
                </div>

                <div class="addContentWrap border-bottom-0" *ngIf="!assessment_id && moduleName.value.length > 1 && moduleDesc.value.length > 1">
                    <a href="javascript:void(0);" class="btn-link" (click)="addAssesment()">+ ADD Module assessment</a>
                    <div *ngIf="submitted && !assessment_id">
                        <div class="text-mute text-danger errorText">Please Add Assessment</div>
                    </div>
                </div>
                <div class="ml-auto position-relative" *ngIf="assessment_id">
                    <a href="javascript:void(0);" class="btn-link text-uppercase ml-1 mr-1"
                        (click)="editAssesment()"><span>View/Edit Assessment</span></a>
                    <div class="removePosition" (click)="open(deleteAssessMod)">
                        <a href="javascript:void(0);" class="btn-remove"><img
                                src="assets/images/admin/delete.svg" />Remove</a>
                    </div>
                </div>

            </div>
            <div class="sttperFooter">
                <div class="row m-0">
                    <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)="open(cancel)">Cancel</a>
                    <a href="javascript:void(0);" class="backPage ml-2 mr-2" *ngIf="type == 'edit'" [routerLink]="['/courses_create']" [queryParams]="{Id:courseId,type:'edit'}">Back</a>
                    <a href="javascript:void(0);" class="backPage ml-2 mr-2" *ngIf="pro == 'review'" [routerLink]="['/courses_create']" [queryParams]="{Id:courseId,pro:'review'}">Back</a>
                    <a href="javascript:void(0);" class="backPage ml-2 mr-2" *ngIf="type != 'edit' && pro != 'review'" [routerLink]="['/courses_create']" [queryParams]="{Id:courseId}">Back</a>
                    <!-- <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)="open(back)">Back</a> -->
                    <div class="ml-auto">
                        <a  *ngIf="type =='' || type == null" href="javascript:void(0);" class="btn btn-primary btn-sm btn-border" [ngClass]=" (moduleName.value.length < 1) ? 'btn btn-primary btn-sm btn-border  disableborder ' :
         'btn btn-primary btn-sm btn-border' " (click)="createCourseAddModules(2,0)"><span>Save as Draft</span></a>
                        <a href="javascript:void(0);" class="btn btn-primary btn-sm ml-2 mr-2"
                            [ngClass]=" (moduleName.value.length < 1 || moduleDesc.value.length < 1) ? 'btn btn-primary btn-sm btn-secondary ml-2 mr-2  disableborder ' : 'btn btn-primary btn-sm ml-2 mr-2' "
                            (click)="createCourseAddModules(1,1)">Save & Add new module</a>
                        <!-- <a href="javascript:void(0);" class="btn btn-primary btn-sm btn-secondary ml-2 mr-2"
         [ngClass]=" (moduleName.value.length < 1 ) ? 'btn btn-primary btn-sm btn-secondary ml-2 mr-2  disableborder ' : 'btn btn-primary btn-sm btn-secondary ml-2 mr-2' " 
         (click)="addModule(1)">Save & Add new module</a> -->
                        <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                            [ngClass]=" (moduleName.value.length < 1 || moduleDesc.value.length < 1) ? 'btn btn-primary btn-sm btn-secondary ml-2 mr-2  disableborder ' : 'btn btn-primary btn-sm' "
                            (click)="createCourseAddModules(3,1)">Review</a>
                    </div>
                </div>
            </div>
        </div>
    </form>
</ng-continer>

<!--cancle capsule model-->
<ng-template #back let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Back to course module</h6>
                <p class="size18">Are you sure you would like to back to course module?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">Cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="cancelbkCourse()">Confirm</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #deleteAssessMod let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Delete Assessment</h6>
                <p class="size18">Are you sure you would like to delete this assessment?</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="deleteAssessment(assessment_id)">Confirm</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #cancel let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Cancel Add Module</h6>
                <p class="size18">Are you sure you would like to Cancel Add Module?</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="cancelCourse()">Confirm</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #delete let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Delete Module</h6>
                <p class="size18">Are you sure you would like to delete Module?</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">cancel</a>
                <a *ngIf="DeleteModuleId !=''" href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="deletesModules(DeleteModuleId,IndModule)">Confirm</a>
                <a *ngIf="DeleteModuleId ==''" href="javascript:void(0);" class="btn btn-primary btn-sm"
                (click)="deletesModules(DeleteModuleId,IndModule)">Confirm</a>
                <!-- <a *ngIf="DeleteModuleId ==''" href="javascript:void(0);" class="btn btn-primary btn-sm"
                (click)="getModuleDetails(DeleteModuleId,IndModule)">Confirm2</a> -->
            </div>
        </div>
    </div>
</ng-template>

<app-add-module-assessment *ngIf="moveToAddModule && moveToAddCapsule == false && moveToViewCapsule == false" (finalSubmit)="retFromAddAss($event)"
    [assData]="assessment_id">
</app-add-module-assessment>
<app-course-content-capsule *ngIf="moveToAddModule && moveToAddCapsule == true && moveToViewCapsule == false" (finalSubmitCap)="retFromAddCap($event)"
    [capData]="capsule_id"></app-course-content-capsule>
<app-view-capsule *ngIf="moveToAddModule && moveToAddCapsule == false && moveToViewCapsule == true" (finalViewCap)="backFromCapsule($event)"
    [capsuleData]="capsuleData_id"></app-view-capsule>